/*
  Wishlist celebrate + guest login prompt.
  Shared by collection cards, search, cart YML, and PDP hearts.
  Kept out of global-product.js so catalog pages still get confetti.
*/
(function () {
  if (window.MYDPdpWishlist?.bind) {
    try {
      window.MYDPdpWishlist.bind();
    } catch (err) {}
    return;
  }

  window.MYDPdpWishlist = {
    _lastFire: 0,
    _lastPrompt: 0,
    _promptAutoCloseTimer: null,
    _promptAutoCloseMs: 6500,

    isLoggedIn() {
      return !!window.MYD_CUSTOMER_LOGGED_IN;
    },

    returnToPath() {
      return `${window.location.pathname}${window.location.search}${window.location.hash}` || '/';
    },

    loginUrl() {
      return `/account/login?return_to=${encodeURIComponent(this.returnToPath())}`;
    },

    registerUrl() {
      return `/account/register?return_to=${encodeURIComponent(this.returnToPath())}`;
    },

    clearLoginPromptAutoClose() {
      if (this._promptAutoCloseTimer) {
        window.clearTimeout(this._promptAutoCloseTimer);
        this._promptAutoCloseTimer = null;
      }
    },

    closeLoginPrompt() {
      this.clearLoginPromptAutoClose();
      document.querySelector('.myd-wishlist-login-prompt')?.classList.remove('is-open');
    },

    scheduleLoginPromptAutoClose() {
      this.clearLoginPromptAutoClose();
      this._promptAutoCloseTimer = window.setTimeout(() => {
        this._promptAutoCloseTimer = null;
        this.closeLoginPrompt();
      }, this._promptAutoCloseMs);
    },

    showLoginPrompt() {
      if (this.isLoggedIn()) return;
      const now = Date.now();
      if (this._lastPrompt && now - this._lastPrompt < 1500) return;
      this._lastPrompt = now;

      let prompt = document.querySelector('.myd-wishlist-login-prompt');
      if (prompt && !prompt.querySelector('.myd-wishlist-login-prompt__icon')) {
        prompt.remove();
        prompt = null;
      }
      if (!prompt) {
        prompt = document.createElement('div');
        prompt.className = 'myd-wishlist-login-prompt';
        prompt.setAttribute('role', 'dialog');
        prompt.setAttribute('aria-modal', 'true');
        prompt.setAttribute('aria-label', 'Save your wishlist');
        prompt.innerHTML = `
          <div class="myd-wishlist-login-prompt__sheet">
            <div class="myd-wishlist-login-prompt__handle" aria-hidden="true"></div>
            <button type="button" class="myd-wishlist-login-prompt__close" aria-label="Close">
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>
            </button>
            <div class="myd-wishlist-login-prompt__icon" aria-hidden="true">
              <svg viewBox="0 0 24 24"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/></svg>
            </div>
            <p class="myd-wishlist-login-prompt__title">Saved for this session</p>
            <p class="myd-wishlist-login-prompt__text">Log in to keep your wishlist permanently — we’ll bring you right back here.</p>
            <div class="myd-wishlist-login-prompt__actions">
              <a class="myd-wishlist-login-prompt__login" data-myd-wish-login>Log in</a>
              <a class="myd-wishlist-login-prompt__register" data-myd-wish-register>Create account</a>
            </div>
          </div>
        `;
        document.body.appendChild(prompt);

        const close = () => this.closeLoginPrompt();
        prompt.querySelector('.myd-wishlist-login-prompt__close')?.addEventListener('click', close);
        prompt.addEventListener('click', (event) => {
          if (event.target === prompt) close();
        });
      }

      const login = prompt.querySelector('[data-myd-wish-login]');
      const register = prompt.querySelector('[data-myd-wish-register]');
      if (login) login.setAttribute('href', this.loginUrl());
      if (register) register.setAttribute('href', this.registerUrl());

      prompt.classList.add('is-open');
      this.scheduleLoginPromptAutoClose();
    },

    onWishAdded(anchor) {
      this.fire(anchor);
      if (!this.isLoggedIn()) this.showLoginPrompt();
    },

    loadConfetti() {
      if (window.MYDConfetti) return Promise.resolve(window.MYDConfetti);
      if (window.__mydConfettiPromise) return window.__mydConfettiPromise;

      const sources = [
        'https://cdn.jsdelivr.net/npm/canvas-confetti@1.9.3/dist/confetti.browser.min.js',
        'https://unpkg.com/canvas-confetti@1.9.3/dist/confetti.browser.min.js'
      ];

      window.__mydConfettiPromise = new Promise((resolve) => {
        const existing = document.querySelector('script[data-myd-confetti]');
        if (existing) {
          if (window.confetti) {
            window.MYDConfetti = window.confetti;
            resolve(window.MYDConfetti);
            return;
          }
          existing.addEventListener(
            'load',
            () => {
              window.MYDConfetti = window.confetti;
              resolve(window.MYDConfetti || null);
            },
            { once: true }
          );
          existing.addEventListener('error', () => resolve(null), { once: true });
          return;
        }

        const tryLoad = (index) => {
          if (index >= sources.length) {
            resolve(null);
            return;
          }
          const script = document.createElement('script');
          script.src = sources[index];
          script.async = true;
          script.dataset.mydConfetti = '1';
          script.onload = () => {
            window.MYDConfetti = window.confetti;
            resolve(window.MYDConfetti || null);
          };
          script.onerror = () => {
            script.remove();
            tryLoad(index + 1);
          };
          document.head.appendChild(script);
        };

        tryLoad(0);
      });

      return window.__mydConfettiPromise;
    },

    getProductInfoRoot() {
      return document.querySelector('.product__info-container');
    },

    findTitleWishButton() {
      return this.getProductInfoRoot()?.querySelector('.myd-pdp-wish') || document.querySelector('.myd-pdp-wish');
    },

    setPdpHeartUI(button, hearted) {
      if (!button) return;
      button.classList.toggle('is-hearted', !!hearted);
      button.setAttribute('aria-pressed', hearted ? 'true' : 'false');
      button.setAttribute('aria-label', hearted ? 'Remove from wishlist' : 'Add to wishlist');
    },

    syncButton(button) {
      if (!button) return;
      const handle = button.getAttribute('data-product-handle');
      this.setPdpHeartUI(button, !!(handle && window.MydWishlist?.hasItem(handle)));
    },

    syncAll() {
      document.querySelectorAll('.myd-pdp-wish').forEach((button) => this.syncButton(button));
    },

    syncPdpWishButtons() {
      this.syncAll();
    },

    toggleWish(button) {
      if (!button || !window.MydWishlist) return;
      const handle = button.getAttribute('data-product-handle');
      if (!handle) return;

      const already = window.MydWishlist.hasItem(handle);
      window.MydWishlist.toggle('default', handle);
      this.setPdpHeartUI(button, !already);
      if (!already) this.onWishAdded(button);
    },

    async fire(anchor) {
      const now = Date.now();
      if (this._lastFire && now - this._lastFire < 450) return;
      this._lastFire = now;

      if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
      const confetti = await this.loadConfetti();
      if (!confetti) return;

      const el = anchor?.isConnected ? anchor : this.findTitleWishButton();
      const rect = el?.getBoundingClientRect?.();
      const origin = {
        x: rect ? (rect.left + rect.width / 2) / window.innerWidth : 0.85,
        y: rect ? (rect.top + rect.height / 2) / window.innerHeight : 0.2
      };
      const colors = ['#ffcc00', '#f43f5e', '#fb7185', '#fda4af', '#ffffff', '#e879f9'];
      const burst = (options) =>
        confetti({
          ...options,
          origin,
          colors,
          disableForReducedMotion: true,
          zIndex: 1000000002
        });

      burst({ particleCount: 120, spread: 72, startVelocity: 52, scalar: 1, ticks: 140 });
      burst({ particleCount: 80, spread: 115, startVelocity: 38, scalar: 1.1, ticks: 160 });
      burst({ particleCount: 60, spread: 360, startVelocity: 28, gravity: 0.6, scalar: 0.85, ticks: 120 });
      burst({ particleCount: 40, spread: 55, startVelocity: 58, scalar: 1.2, ticks: 100 });
    },

    bind() {
      if (this.bound) return;
      this.bound = true;

      document.addEventListener(
        'click',
        (event) => {
          const button = event.target.closest?.('.myd-pdp-wish');
          if (!button) return;
          event.preventDefault();
          event.stopPropagation();
          this.toggleWish(button);
          try {
            button.blur();
          } catch (err) {}
        },
        true
      );

      document.addEventListener('wishlist:updated', () => this.syncAll());

      const boot = () => this.syncAll();
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot, { once: true });
      } else {
        boot();
      }
      document.addEventListener('productInfo:loaded', () => {
        window.setTimeout(boot, 0);
      });

      this.loadConfetti();
    }
  };

  try {
    window.MYDPdpWishlist.bind();
  } catch (err) {
    /* wishlist must never block page boot */
  }
})();
